module.exports = {
  dimensions: {
    width: 140,
    height: 71
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  nine: {
    top: 0,
    left: 0,
    right: 140,
    bottom: 0
  }
};